export default {
  "mainVegetable": "koogiviljad",
  "mainVegetable/01": "koogiviljad/baklazaan",
  "mainVegetable/02": "koogiviljad/aspar",
  "mainVegetable/03": "koogiviljad/avokaado",
  "mainVegetable/04": "koogiviljad/peet",
  "mainVegetable/05": "koogiviljad/brokoli",
  "mainVegetable/06": "koogiviljad/porgand",
  "mainVegetable/07": "koogiviljad/seller",
  "mainVegetable/08": "koogiviljad/sampinjon",
  "mainVegetable/09": "koogiviljad/kapsas",
  "mainVegetable/10": "koogiviljad/brusseli-kapsas",
  "mainVegetable/11": "koogiviljad/hiina-kapsas",
  "mainVegetable/12": "koogiviljad/lillkapsas",
  "mainVegetable/13": "koogiviljad/coleslaw",
  "mainVegetable/14": "koogiviljad/kurk",
  "mainVegetable/15": "koogiviljad/suvikorvits",
  "mainVegetable/16": "koogiviljad/kahar-endiiviasigur",
  "mainVegetable/17": "koogiviljad/spinat",
  "mainVegetable/18": "koogiviljad/fava-aedoad",
  "mainVegetable/19": "koogiviljad/flageolet-aedoad",
  "mainVegetable/20": "koogiviljad/lamedad-aedoad",
  "mainVegetable/21": "koogiviljad/kuivatatud-oad",
  "mainVegetable/22": "koogiviljad/rohelised-aedoad",
  "mainVegetable/23": "koogiviljad/laatsed",
  "mainVegetable/24": "koogiviljad/koogiviljasegu",
  "mainVegetable/25": "koogiviljad/mais",
  "mainVegetable/26": "koogiviljad/salat-mix",
  "mainVegetable/27": "koogiviljad/naeris",
  "mainVegetable/28": "koogiviljad/sibul",
  "mainVegetable/29": "koogiviljad/soya-oad",
  "mainVegetable/30": "koogiviljad/paprika",
  "mainVegetable/31": "koogiviljad/kartul",
  "mainVegetable/32": "koogiviljad/soya-oad-idud",
  "mainVegetable/33": "koogiviljad/redis",
  "mainVegetable/34": "koogiviljad/tammelehesalat",
  "mainVegetable/35": "koogiviljad/frisee-salat",
  "mainVegetable/36": "koogiviljad/iceberg-salat",
  "mainVegetable/37": "koogiviljad/piedmontese-salat",
  "mainVegetable/38": "koogiviljad/riisi-koogiviljad",
  "mainVegetable/39": "koogiviljad/romaa-salat",
  "mainVegetable/40": "koogiviljad/idud",
  "mainVegetable/41": "koogiviljad/salat",
  "mainVegetable/42": "koogiviljad/lamb-salat",
  "mainVegetable/43": "koogiviljad/rukola",
  "mainVegetable/44": "koogiviljad/pastinaak",
  "mainVegetable/45": "koogiviljad/taboule",
  "mainVegetable/46": "koogiviljad/tomat",
  "mainVegetable/47": "koogiviljad/voioad",
  "mainVegetable/48": "koogiviljad/kikerherned",
  "mainVegetable/49": "koogiviljad/porrulauk",
  "mainVegetable/50": "koogiviljad/korvits",
  "mainVegetable/51": "koogiviljad/punased-oad",
  "mainVegetable/52": "koogiviljad/oun",
  "mainVegetable/53": "koogiviljad/kastan",
  "mainVegetable/54": "koogiviljad/ploom",
  "mainVegetable/55": "koogiviljad/gardener",
  "mainVegetable/56": "koogiviljad/mustad-oliivid",
  "mainVegetable/57": "koogiviljad/artisokk",
  "mainVegetable/58": "koogiviljad/punane-paprika",
  "mainVegetable/59": "koogiviljad/rohalised-turgi-oad",
  "mainVegetable/60": "koogiviljad/spring",
  "mainVegetable/61": "koogiviljad/hautis",
  "mainVegetable/62": "koogiviljad/kuskuss",
  "mainVegetable/63": "koogiviljad/tajine",
  "mainVegetable/64": "koogiviljad/curry-vegetables",
  "mainVegetable/65": "koogiviljad/pea-cups",
  "mainVegetable/66": "koogiviljad",
  "mainVegetable/67": "koogiviljad/koralllaatsed",
  "mainVegetable/68": "koogiviljad/kinoa",
  "mainVegetable/69": "koogiviljad/spelta",
  "mainVegetable/70": "koogiviljad/bulgur",
  "mainVegetable/71": "koogiviljad/punane-kapsas",
  "mainVegetable/72": "koogiviljad/lehtkapsas",
  "mainVegetable/73": "koogiviljad/petersell",
  "mainVegetable/74": "koogiviljad/teravilja-ja-seemnete",
  "mainVegetable/75": "koogiviljad/koogiviljad",
  "mainVegetable/76": "koogiviljad/maguskartul",
  "mainVegetable/77": "koogiviljad/korvits",
  "mainVegetable/78": "koogiviljad/tainas",
  "mainVegetable/79": "koogiviljad/aedoad",
  "mainVegetable/80": "koogiviljad/herned-porgand",
  "mainVegetable/81": "koogiviljad/herned",
  "mainVegetable/82": "koogiviljad/edamame-aedoad",
  "mainVegetable/83": "koogiviljad/oder",
  "mainVegetable/84": "koogiviljad/salatisegu",
  "mainVegetable/85": "koogiviljad/sugar-loaf-chicory",
  "mainVegetable/86": "koogiviljad/lamb-lettuce",
  "mainVegetable/87": "koogiviljad/spinat",
  "mainVegetable/88": "koogiviljad/baby-green-batavia",
  "mainVegetable/89": "koogiviljad/swiss-chard",
  "mainVegetable/90": "koogiviljad",
  "mainVegetable/91": "koogiviljad",
  "mainVegetable/92": "koogiviljad",
  "mainVegetable/93": "koogiviljad",
  "mainVegetable/94": "koogiviljad",
  "mainVegetable/95": "koogiviljad",
  "mainVegetable/96": "koogiviljad",
  "mainVegetable/97": "koogiviljad",
  "mainVegetable/98": "koogiviljad",
  "season": "hooaeg",
  "season/1": "hooaeg/suvi",
  "season/2": "hooaeg/sugis",
  "season/3": "hooaeg/talv",
  "season/4": "hooaeg/kevad",
  "season/5": "hooaeg",
  "technologie": "valmistamine",
  "technologie/AC01": "valmistamine/konserveeritud",
  "technologie/AD01": "valmistamine/kulmutatud",
  "technologie/AG01": "valmistamine/varske",
  "technologie/AT01": "valmistamine/caterer",
  "recipeDish": "roog",
  "recipeDish/ACC": "roog/garniir",
  "recipeDish/APE": "roog/garniir",
  "recipeDish/DES": "roog/magustoit",
  "recipeDish/ENT": "roog/suupisted",
  "recipeDish/PLAT": "roog/pearoogadele",
  "recipeDish/SAL": "roog/salatid",
  "recipeDish/SNA": "roog/suupisted",
  "recipeDish/PDE": "roog/hommikusook",
  "recipeDish/DEJ": "roog/iounasook",
  "recipeDish/TRA": "roog/traditsioonilised",
  "recipeDish/GOU": "roog/suupiste",
  "recipeDish/ETH": "roog/traditsioonilised",
  "recipeDish/FCH": "roog/lastele",
  "recipeDish/SOU": "roog/supid",
  "pred-recipeTimingCook-facet": "kupsetusaeg",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "kupsetusaeg/0-15-minuteid",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "kupsetusaeg/15-30-minuteid",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "kupsetusaeg/30-45-minuteid",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "kupsetusaeg/45-minuteid",
  "pred-recipeTimingPreparation-facet": "valmistusaeg",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "valmistusaeg/0-15-minuteid",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "valmistusaeg/15-30-minuteid",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "valmistusaeg/30-45-minuteid",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "valmistusaeg/45-minuteid",
  "pred-recipeCost-Facet": "hind",
  "pred-recipeCost-Facet/petit": "hind/odav",
  "pred-recipeCost-Facet/moyen": "hind/keskmine",
  "pred-recipeCost-Facet/grand": "hind/kallis",
  "recipeDifficulty": "valmistamine",
  "recipeDifficulty/1": "valmistamine/kerge",
  "recipeDifficulty/2": "valmistamine/keskmine",
  "recipeDifficulty/3": "valmistamine/keeruline",
  "recipeDishNumber": "portsjonite-arv",
  "recipeDishNumber/1": "portsjonite-arv/1",
  "recipeDishNumber/2": "portsjonite-arv/2",
  "recipeDishNumber/3": "portsjonite-arv/3",
  "recipeDishNumber/4": "portsjonite-arv/4",
  "recipeDishNumber/5": "portsjonite-arv/5",
  "recipeDishNumber/6": "portsjonite-arv/6",
  "recipeDishNumber/7": "portsjonite-arv/7",
  "recipeDishNumber/8": "portsjonite-arv/8",
  "productTheme": "toote-teema",
  "productTheme/ACC": "toote-teema/garniir",
  "productTheme/BEA": "toote-teema/aedoad",
  "productTheme/BIS": "toote-teema/oad-kastmes",
  "productTheme/BIO": "toote-teema/eco",
  "productTheme/CAN": "toote-teema/konserveeritud",
  "productTheme/CER": "toote-teema",
  "productTheme/CLS": "toote-teema/klassikaline",
  "productTheme/DLE": "toote-teema/koogiviljad",
  "productTheme/EDR": "toote-teema/roogade-sober",
  "productTheme/ENT": "toote-teema/suupisted",
  "productTheme/FRZ": "toote-teema/kulmutatud",
  "productTheme/FSD": "toote-teema/salat-mix",
  "productTheme/FSH": "toote-teema/hind",
  "productTheme/ING": "toote-teema/koostisained-minu-retseptile",
  "productTheme/JAR": "toote-teema/koogiviljad-purgis",
  "productTheme/LBW": "toote-teema",
  "productTheme/LDF": "toote-teema/koogiviljad-kupsetamiseks",
  "productTheme/LEG": "toote-teema",
  "productTheme/LGO": "toote-teema/koogiviljad",
  "productTheme/LGR": "toote-teema/grill-koogiviljad",
  "productTheme/LGS": "toote-teema",
  "productTheme/MAI": "toote-teema/majonees",
  "productTheme/MUS": "toote-teema/sampinjon",
  "productTheme/NEW": "toote-teema/uudised",
  "productTheme/PDH": "toote-teema/dry-vegetable-kitchen-dishes",
  "productTheme/PDL": "toote-teema/basket-of-vegetables",
  "productTheme/PHR": "toote-teema/pasta-and-pasta",
  "productTheme/PLP": "toote-teema/pearoogadele",
  "productTheme/RAL": "toote-teema/riisi-koogiviljad",
  "productTheme/RDM": "toote-teema/road",
  "productTheme/SAL": "toote-teema/koik-minu-salatitele",
  "productTheme/SDB": "toote-teema/salat-roogadele",
  "productTheme/SNK": "toote-teema/suupisted",
  "productTheme/SUP": "toote-teema/supid",
  "productTheme/TEX": "toote-teema/tex-mex",
  "productTheme/VGP": "toote-teema/koogiviljad-valgud",
  "recipeTheme": "retseptide-teema",
  "recipeTheme/01": "retseptide-teema/pearoad",
  "recipeTheme/02": "retseptide-teema/suupisted",
  "recipeTheme/03": "retseptide-teema/salat-ja-suupised",
  "recipeTheme/04": "retseptide-teema/supid",
  "recipeTheme/05": "retseptide-teema/pirukad",
  "recipeTheme/06": "retseptide-teema/lastele",
  "recipeTheme/07": "retseptide-teema/magustoit",
  "recipeTheme/08": "retseptide-teema/taometoit",
  "recipeTheme/09": "retseptide-teema/lisadeta",
  "recipeTheme/10": "retseptide-teema/kaasavotmiseks",
  "recipeTheme/11": "retseptide-teema/mijotes",
  "recipeTheme/12": "retseptide-teema/salat-ja-barbeque",
  "recipeTheme/13": "retseptide-teema/salat-ja-suupised",
  "recipeTheme/14": "retseptide-teema/pearoogadele",
  "recipeTheme/15": "retseptide-teema/magustoit-ja-kupsetised",
  "recipeTheme/16": "retseptide-teema/suupised-ja-supid",
  "recipeTheme/17": "retseptide-teema/salatid",
  "recipeTheme/18": "retseptide-teema/kauss",
  "recipeTheme/19": "retseptide-teema/supid",
  "recipeTheme/20": "retseptide-teema/suupised",
  "recipeTheme/21": "retseptide-teema/kaste",
  "recipeTheme/22": "retseptide-teema/uks-roog",
  "recipeTheme/23": "retseptide-teema/teised-road",
  "recipeTheme/24": "retseptide-teema/roog-neljale",
  "recipeTheme/25": "retseptide-teema",
  "recipeTheme/26": "retseptide-teema",
  "recipeTheme/27": "retseptide-teema",
  "recipeTheme/28": "retseptide-teema",
  "recipeTheme/33": "retseptide-teema",
  "recipeTheme/34": "retseptide-teema",
  "recipeTheme/35": "retseptide-teema",
  "recipeTheme/36": "retseptide-teema",
  "recipeTheme/37": "retseptide-teema",
  "recipeTheme/38": "retseptide-teema",
  "recipeTheme/39": "retseptide-teema",
  "recipeTheme/40": "retseptide-teema",
  "recipeTheme/41": "retseptide-teema",
  "recipeTheme/42": "retseptide-teema",
  "recipeTheme/43": "retseptide-teema",
  "recipeTheme/44": "retseptide-teema",
  "recipeTheme/45": "retseptide-teema",
  "recipeTheme/46": "retseptide-teema",
  "pred-particularite": "partikas-specifika",
  "pred-particularite/Sans%20conservateur": "toidueelised/ei-sisalda-sailitusaineid",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "toidueelised",
  "pred-particularite/Sans%20colorant": "toidueelised/ei-sisalda-toiduvarve",
  "pred-particularite/Sans%20sucre%20ajout%E9": "toidueelised/ilma-lisatud-suhkruta",
  "pred-particularite/Sans%20sel%20ajout%E9": "toidueelised/ilma-lisatud-soolata",
  "pred-particularite/Sans%20additif": "toidueelised/lisadeta",
  "pred-particularite/": "toidueelised/ilma-lisatud-soolata",
  "pred-particularite/Sans%20lactose": "toidueelised/ei-sisalda-laktoosi",
  "pred-particularite/Sans%20gluten": "toidueelised/ei-sisalda-guteeni",
  "pred-particularite/V%E9g%E9tarien": "toidueelised/taimetoit",
  "pred-particularite/V%E9g%E9talien": "toidueelised/vegantoit",
  "pred-particularite/Sans%20sulfite": "toidueelised",
  "pred-particularite/A%20la%20vapeur": "toidueelised",
  "pred-particularite/Sans%20condiment": "toidueelised",
  "cultureType": "kultuuri-tuup",
  "cultureType/Bio": "kultuuri-tuup/eco",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "kultuuri-tuup/ei-sisalda-pestitsiide",
  "cultureType/Sans%20OGM": "kultuuri-tuup/ei-sisalda-gmo-d",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "partikas-specifika/vegantoit",
  "pred-particularite/recipeVeggie": "partikas-specifika/taimetoit",
  "pred-particularite/recipeGlutenfree": "partikas-specifika/ei-sisalda-guteeni",
  "pred-particularite/recipeLactosefree": "partikas-specifika/ei-sisalda-laktoosi"
};
